module.exports = __webpack_public_path__ + "static/ice-right-383f1890c930f698a4c70c622b6c0731.png";